/**
 * @typedef {Object} CartItem
 * @property {string} id
 * @property {string} name
 * @property {string} category
 * @property {number} price
 * @property {number} quantity
 * @property {string} variantKey
 * @property {string} [variantLabel]
 * @property {string} [image]
 * @property {number} [stock]
 */

const MAX_FALLBACK_STOCK = 99;

export const getCartKey = (id, variantKey) => `${id}:${variantKey}`;

export const addCartItem = (items, item) => {
  if (item.stock !== undefined && item.stock <= 0) {
    return items;
  }

  const existing = items.find(
    (entry) => entry.id === item.id && entry.variantKey === item.variantKey
  );

  if (existing) {
    const maxStock = item.stock ?? existing.stock ?? MAX_FALLBACK_STOCK;
    if (existing.quantity >= maxStock) {
      return items;
    }
    const nextQuantity = Math.min(existing.quantity + 1, maxStock);
    return items.map((entry) =>
      entry.id === item.id && entry.variantKey === item.variantKey
        ? { ...entry, quantity: nextQuantity }
        : entry
    );
  }

  return [...items, { ...item, quantity: 1 }];
};

export const updateCartQuantity = (items, id, variantKey, delta) =>
  items
    .map((entry) => {
      if (entry.id !== id || entry.variantKey !== variantKey) {
        return entry;
      }
      const nextQuantity = Math.max(
        1,
        Math.min(entry.quantity + delta, entry.stock ?? MAX_FALLBACK_STOCK)
      );
      return { ...entry, quantity: nextQuantity };
    })
    .filter((entry) => entry.quantity > 0);

export const removeCartItem = (items, id, variantKey) =>
  items.filter((entry) => !(entry.id === id && entry.variantKey === variantKey));

export const getCartCount = (items, selectedPlan) => {
  const itemsCount = items.reduce((sum, item) => sum + item.quantity, 0);
  return itemsCount + (selectedPlan ? 1 : 0);
};
